export default __webpack_public_path__ + "media/zurb/img/bryan/fav-posts/product_research_methods_lingo-f6f5e12ca965b648764dd918da88972b.png";